var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeItem.missionStatement)?_c('widget',{attrs:{"widget-id":_vm.widgetId,"title":_vm.$t('document.mission'),"icon":"file"}},[_c('div',{staticClass:"md",domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }